export default __webpack_public_path__ + "static/media/medium-crumb1.2c9ff823.png";